import React, { useEffect, useRef } from "react";
import Markdown from "react-markdown";
//
import { Box, Grid, TypingLoader, Typography } from "@/components";
import {
  CHAT_GA4_EVENTS,
  isAcesseAquiAppLink,
  messageContainsAcesseAquiLink,
  notifyParentChatGa4,
} from "@/utils/parentGa4Analytics";
//
import Feedback from "../Feedback";
import { StyledBox, StyledIntent, StyledMarkdownLink } from "./style";

const MessageViewer = ({
  onFeedback,
  feedback,
  children,
  asking,
  isFirstBotMessage,
  messageId,
}) => {
  const textContent = Array.isArray(children) ? children.join("") : children;
  const linkViewSentRef = useRef(false);

  useEffect(() => {
    if (asking || !messageId || linkViewSentRef.current) {
      return;
    }

    if (typeof textContent === "string" && messageContainsAcesseAquiLink(textContent)) {
      linkViewSentRef.current = true;
      notifyParentChatGa4(CHAT_GA4_EVENTS.LINK_VIEW);
    }
  }, [asking, messageId, textContent]);

  if (typeof textContent === "string") {
    const parts = textContent.split("[::feedback_here]");

    return (
      <>
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            <Markdown
              components={{
                a: ({ node, ...props }) => {
                  const handleClick = (event) => {
                    if (isAcesseAquiAppLink(props.href, props.children)) {
                      notifyParentChatGa4(CHAT_GA4_EVENTS.LINK_CLICK);
                    }
                    props.onClick?.(event);
                  };

                  return (
                    <StyledMarkdownLink
                      {...props}
                      asking={asking.toString()}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={handleClick}
                    >
                      {props.children}
                    </StyledMarkdownLink>
                  );
                },
                img: ({ node, ...props }) => (
                  <img
                    {...props}
                    style={{
                      maxWidth: "200px",
                      maxHeight: "150px",
                      width: "auto",
                      height: "auto",
                      borderRadius: "8px",
                      marginTop: "8px",
                      marginBottom: "8px",
                    }}
                    alt={props.alt || "Imagem"}
                  />
                ),
              }}
            >
              {part}
            </Markdown>
            {index < parts.length - 1 && !isFirstBotMessage && (
              <Feedback onFeedback={onFeedback} feedback={feedback}>
                Esta resposta foi util?
              </Feedback>
            )}
          </React.Fragment>
        ))}
        {parts.length === 1 && !asking && !isFirstBotMessage && (
          <Feedback onFeedback={onFeedback} feedback={feedback}>
            Esta resposta foi util?
          </Feedback>
        )}
      </>
    );
  }

  return <Typography>{children}</Typography>;
};

const Message = (props) => {
  const {
    children,
    thinking = false,
    asking = false,
    feedback = null,
    messageId = null,
    options = [],
    onIntent = () => {},
    onFeedback,
    isFirstBotMessage = false,
    ...otherProps
  } = props;

  const handleFeedback = (args) =>
    onFeedback({
      messageId,
      ...args,
    });

  return (
    <StyledBox asking={asking.toString()} {...otherProps}>
      <Grid container alignItems="flex-start" flexWrap={"nowrap"}>
        <Grid flexDirection="column">
          <Typography variant="body1" component="div">
            {thinking && (
              <img
                src="/static/images/avatar/chatbot-icone-conversa%20(1).svg"
                alt="Pensando"
                style={{ width: 18, height: 18, verticalAlign: "middle" }}
              />
            )}
            {children ? (
              <MessageViewer
                onFeedback={handleFeedback}
                feedback={feedback}
                asking={asking}
                isFirstBotMessage={isFirstBotMessage}
                messageId={messageId}
              >
                {children}
              </MessageViewer>
            ) : (
              !thinking && <TypingLoader />
            )}
            <Box>
              {options &&
                options.map((intent, index) => {
                  const key = `opt-intent-${index}`;

                  return (
                    <StyledIntent
                      key={key}
                      color="primary"
                      variant="contained"
                      onClick={() => onIntent(intent)}
                    >
                      <Typography>{intent.name}</Typography>
                    </StyledIntent>
                  );
                })}
            </Box>
          </Typography>
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export default Message;
